import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface State {
    totalReports: number;
	refreshReport:boolean;
    dataLoaded: boolean;
	reportData: []
}

const initialState: State = {
	dataLoaded: false,
	refreshReport: false,
	reportData: [],
	totalReports: 0
};

const reportsSlice = createSlice({
	initialState,
	name: 'reports',
	reducers: {
		refreshReport: (
			state,
			action: PayloadAction<boolean>
		) => {
			if (action.payload) {
				state.refreshReport = action.payload;
			}
		},
		reportData: (state, action: PayloadAction<any> ) => {
			state.reportData = action.payload;
		},
		reportsReset: () => initialState,
		setRecordDataLoadedFlag: (
			state,
			action: PayloadAction<boolean>
		) => {
			state.dataLoaded = action.payload;
		},
		totalReports: (
			state,
			action: PayloadAction<number | undefined>
		) => {
			if (action.payload) {
				state.totalReports = action.payload;
			}
		}
	},
});

export const { totalReports, refreshReport, reportData, reportsReset } = reportsSlice.actions;
export default reportsSlice.reducer;